import styled, { DefaultTheme } from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';

interface DeliveryOptionCardContainerProps {
  $selected?: boolean;
}

export const DeliveryOptionCardOuterWrapper = styled.div<DeliveryOptionCardContainerProps>`
  scroll-margin-top: 80px;
  position: relative;
  border: 1.5px solid ${({ theme }) => theme.colors.baseColors.grey50};
  border-radius: 1.2rem;
  background-color: ${({ theme }) => theme.colors.namedColors.white};

  border-color: ${({ theme, $selected }) =>
    $selected
      ? theme.colors.namedColors.primary
      : theme.colors.baseColors.grey50};

  @media (max-width: 650px) {
    scroll-margin-top: 8px;
    cursor: pointer;
  }
`;

export const TopSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

interface LogoSkeletonWrapperProps {
  $width: string;
  $height: string;
}

export const LogoSkeletonWrapper = styled.div<LogoSkeletonWrapperProps>`
  display: flex;
  align-items: center;
  flex-grow: 0 !important;
  height: ${({ $height }) => $height};

  img {
    width: ${({ $width }) => $width};
  }
`;

export const LogoSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ServiceName = styled.div`
  font-size: ${FontSizes.medium};
  font-style: normal;
  font-weight: 500;
  line-height: 2.2rem; /* 137.5% */
  letter-spacing: 0.5px;
`;

export const DeliveryDirectionText = styled.div`
  font-size: ${FontSizes.small};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.baseColors.grey100};
`;

export const TagContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  svg {
    height: 1.6rem;
    width: 1.6rem;
  }
`;

export const DeliveryOptionCardContainer = styled.div`
  padding: 0 1.6rem;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  width: 100%;
  min-width: 28rem;
  gap: 1.6rem;
  border-radius: 1.2rem;

  @media (max-width: 650px) {
    padding: 0;
    gap: 0;
    flex-direction: column;
  }
`;

export const ExpeditedComment = styled.p`
  color: ${({ theme }) => theme.colors.baseColors.grey100};
  font-family: ${({ theme }) => theme.fonts.body.fontFamily};
  font-size: ${FontSizes.small};
  font-style: italic;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.5px;
  margin-top: 1.2rem;
`;

export type DeliveryInfoTagColor = 'grey' | 'green' | 'red';
interface LabelProps {
  $textColor: DeliveryInfoTagColor;
}

function getTextColor(color: DeliveryInfoTagColor, theme: DefaultTheme) {
  return {
    grey: theme.colors.baseColors.grey100,
    green: theme.colors.baseColors.green100,
    red: theme.colors.baseColors.red100,
  }[color];
}

export const DeliveryInfoTagContainer = styled.span<LabelProps>`
  display: inline-flex;
  align-items: center;
  color: ${(props) => getTextColor(props.$textColor, props.theme)};
  font-size: ${FontSizes.small};
  font-style: normal;
  font-weight: 400;
  line-height: 1.6rem;
  letter-spacing: 0.5px;

  svg {
    margin-right: 4px;
  }

  @media (max-width: 650px) {
    &:not(:last-child)::after {
      content: '•';
      display: inline-flex;
      width: 16px;
      height: 16px;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      line-height: 1;
      margin: 0;
      color: ${(props) => props.theme.colors.baseColors.grey100};
    }
  }
`;

export const MiddleMileExpandedContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const MiddleMileDeliveryTimeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 1.6rem;
    flex-shrink: 0;
  }
`;
